import moment from 'moment';
export const getCurrDate = () => {
    const currDate = new Date();
    return moment(currDate).format("DD-MM-YYYY")
}
export const getLastDate = (data) => {
    console.log(data)
    let currDate = moment(new Date()).format("MM-DD-YYYY")
    console.log(moment(new Date(currDate.substring(0, 3) + data + currDate.substring(5))).format("DD-MM-YYYY"))
    return moment(new Date(currDate.substring(0, 3) + data + currDate.substring(5))).format("DD-MM-YYYY")
}